import { Badge, DataTable, Modal, type TanstackReactTable } from "@devhop/ui";
import { formatDateLocal } from "@/shared/lib/date-time";
import type { JDPositionMappingDTO } from "@/modules/jd-mapping/domain/contracts";

type JDMappingHistoryModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  positionTitle: string;
  mappings: JDPositionMappingDTO[];
  isLoading?: boolean;
};

export function JDMappingHistoryModal({
  open,
  onOpenChange,
  positionTitle,
  mappings,
  isLoading,
}: JDMappingHistoryModalProps) {
  const columns: TanstackReactTable.ColumnDef<JDPositionMappingDTO>[] = [
    {
      id: "jdTitle",
      header: "JD",
      cell: ({ row }) => (
        <span className="font-medium">{row.original.jdTitle || "-"}</span>
      ),
      size: 200,
    },
    {
      id: "status",
      header: "ສະຖານະ",
      cell: ({ row }) => (
        <Badge
          variant={row.original.status === "active" ? "default" : "secondary"}
        >
          {row.original.status === "active" ? "ໃຊ້ງານ" : "ບໍ່ໃຊ້ງານ"}
        </Badge>
      ),
      size: 100,
    },
    {
      id: "startDate",
      header: "ເລີ່ມວັນທີ",
      cell: ({ row }) => (
        <span className="text-sm">
          {formatDateLocal(row.original.startDate)}
        </span>
      ),
      size: 120,
    },
    {
      id: "endDate",
      header: "ສິ້ນສຸດວັນທີ",
      cell: ({ row }) => (
        <span className="text-sm">
          {row.original.endDate
            ? formatDateLocal(row.original.endDate)
            : "-"}
        </span>
      ),
      size: 120,
    },
    {
      id: "assignedByName",
      header: "ຜູ້ກຳນົດ",
      cell: ({ row }) => (
        <span className="text-sm">
          {row.original.assignedByName || row.original.assignedBy}
        </span>
      ),
      size: 150,
    },
    {
      id: "notes",
      header: "ຫມາຍເຫດ",
      cell: ({ row }) => (
        <span className="text-muted-foreground text-sm">
          {row.original.notes || "-"}
        </span>
      ),
      size: 200,
    },
  ];

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={`ປະຫວັດການຜູກ JD - ${positionTitle}`}
      size="lg"
    >
      <div className="max-h-[70vh] overflow-y-auto">
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <p className="text-muted-foreground">ກຳລັງໂຫຼດ...</p>
          </div>
        ) : mappings.length === 0 ? (
          <div className="flex items-center justify-center py-8">
            <p className="text-muted-foreground">ບໍ່ມີປະຫວັດການຜູກ JD</p>
          </div>
        ) : (
          <DataTable data={mappings} columns={columns} />
        )}
      </div>
    </Modal>
  );
}
